import cn from "../../../utils/cn";
import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const BaseCard = _ref => {
  let {
    noBorder = false,
    children,
    className = '',
    id = ''
  } = _ref;
  const cardClass = cn({
    rounded: true,
    'border-solid border border-medium-border-blue': !noBorder
  }, className);
  return /*#__PURE__*/_jsx("div", {
    ...(id ? {
      id
    } : {}),
    ...(id ? {
      'data-testid': id
    } : {}),
    className: cardClass,
    children: children
  });
};
BaseCard.displayName = 'BaseCard';
BaseCard.propTypes = {
  noBorder: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string
};
export default BaseCard;
//# sourceMappingURL=BaseCard.js.map